import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Navbar,
  Button,
  Form,
  InputGroup,
  ListGroup,
  Pagination,
} from 'react-bootstrap';

function MemoListPage({
  searchQuery,
  setSearchQuery,
  searchScope,
  setSearchScope,
  paginatedMemos,
  filteredMemos,
  pageStart,
  itemsPerPage,
  currentPage,
  totalPages,
  itemsPerPageOptions,
  setItemsPerPage,
  setCurrentPage,
  handleNewMemo,
  handlePageChange,
  paginationItems,
}) {
  const navigate = useNavigate();

  const onNewMemo = () => {
    handleNewMemo((id) => navigate(`/memo/${id}`));
  };

  return (
    <>
      <Navbar bg="primary" variant="dark" expand="md" className="shadow-sm">
        <Container>
          <Navbar.Brand className="fw-bold">메모 앱</Navbar.Brand>
          <Navbar.Toggle aria-controls="memo-navbar" />
          <Navbar.Collapse id="memo-navbar">
            <div className="d-flex flex-column flex-md-row align-items-stretch align-items-md-center gap-2 w-100 mt-3 mt-md-0">
              <Button variant="light" className="text-primary fw-semibold" onClick={onNewMemo}>
                새 메모
              </Button>
              <InputGroup className="flex-grow-1">
                <Form.Control
                  type="search"
                  placeholder="메모 검색..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  aria-label="검색어"
                />
                <InputGroup.Text className="bg-white">검색 범위</InputGroup.Text>
                <Form.Select
                  value={searchScope}
                  onChange={(e) => setSearchScope(e.target.value)}
                  style={{ maxWidth: '120px' }}
                  aria-label="검색 범위 선택"
                >
                  <option value="all">전체</option>
                  <option value="title">제목</option>
                  <option value="content">내용</option>
                </Form.Select>
              </InputGroup>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <Container className="py-4">
        {filteredMemos.length === 0 ? (
          <div className="text-center text-muted py-5">
            <p className="mb-0">
              {searchQuery
                ? '검색 결과가 없습니다.'
                : '메모가 없습니다. 새 메모를 만들어 보세요.'}
            </p>
          </div>
        ) : (
          <>
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
              <span className="text-muted small">
                전체 {filteredMemos.length}개 (
                {pageStart + 1}-
                {Math.min(pageStart + itemsPerPage, filteredMemos.length)}{' '}
                표시)
              </span>
              <Form.Select
                size="sm"
                value={itemsPerPage}
                onChange={(e) => {
                  setItemsPerPage(Number(e.target.value));
                  setCurrentPage(1);
                }}
                style={{ width: 'auto' }}
                aria-label="페이지당 개수"
              >
                {itemsPerPageOptions.map((n) => (
                  <option key={n} value={n}>
                    {n}개씩
                  </option>
                ))}
              </Form.Select>
            </div>

            <ListGroup>
              {paginatedMemos.map((memo) => {
                const dateStr = new Date(memo.createdAt).toLocaleString('ko-KR');
                const snippet = memo.content
                  ? memo.content.slice(0, 60) + (memo.content.length > 60 ? '…' : '')
                  : '';
                return (
                  <ListGroup.Item
                    key={memo.id}
                    action
                    onClick={() => navigate(`/memo/${memo.id}`)}
                    className="d-flex justify-content-between align-items-start"
                  >
                    <div className="ms-2 me-auto">
                      <div className="fw-semibold">{memo.title || '(제목 없음)'}</div>
                      {snippet && (
                        <small className="text-muted d-block mt-1">{snippet}</small>
                      )}
                    </div>
                    <small className="text-body-secondary">{dateStr}</small>
                  </ListGroup.Item>
                );
              })}
            </ListGroup>

            {totalPages > 1 && (
              <div className="d-flex justify-content-center mt-4">
                <Pagination>
                  <Pagination.First
                    onClick={() => handlePageChange(1)}
                    disabled={currentPage === 1}
                  />
                  <Pagination.Prev
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  />
                  {paginationItems()}
                  <Pagination.Next
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  />
                  <Pagination.Last
                    onClick={() => handlePageChange(totalPages)}
                    disabled={currentPage === totalPages}
                  />
                </Pagination>
              </div>
            )}
          </>
        )}
      </Container>
    </>
  );
}

export default MemoListPage;
